import { FavoritesBitFlagsMasks, setBit } from '../../helpers/favoritesBitFlagsActions';
import { lazyUpdateUserConfigurationService } from 'owa-session-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import * as trace from 'owa-trace';

/**
 * Hides the first run experience on the persona header
 */
export default function markPersonaHeaderFirstRunCompleted() {
    setBit(true, FavoritesBitFlagsMasks.PersonaHeaderFirstRunSeen);

    lazyUpdateUserConfigurationService
        .importAndExecute([
            {
                key: 'FavoritesBitFlags',
                valuetype: 'Integer32',
                value: [`${getUserConfiguration().UserOptions.FavoritesBitFlags}`],
            },
        ])
        .catch(error => {
            // In case we cannot update the configuration we don't show the FRE in this session again
            trace.errorThatWillCauseAlert('UpdateUserConfigurationFailed: ' + error);
        });
}
